import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useState } from "react";
import GetPayHistoryActionBox from "../ActionIcons/GetPayHistoryActionBox/GetPayHistoryActionBox";
import "./tables_styles.css";
import EmployeeNamePic from "../EmployeeNamePic/EmployeeNamePic";
import PromotionsARModalController from "../../Modals/ActionRequiredModals/PromotionsARModal/PromotionsARModalController";
import TransferARModalController from "../../Modals/ActionRequiredModals/TransferARModal/TransferARModalController";
import TransferReceiveARModalController from "../../Modals/ActionRequiredModals/TransferReceiveARModal/TransferReceiveARModalController";

interface Propval {
  trans: any;
}
const TransferReceive = ({ trans }: Propval) => {
  const [openModal, setOpenModal] = useState(false);

  const tableColumns: any = [
    {
      field: "empId",
      headerName: trans("#Emp Id"),
      width: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      headerClassName: "header",
      height: 70,
    },
    {
      field: "empName",
      headerName: trans("Emp Name"),

      flex: 1,
      headerAlign: "center",
      align: "center",
      headerClassName: "header",
      height: 70,
      renderCell: (params: any) => {
        return <EmployeeNamePic name="Amelia Russel" picture="" />;
      },
    },
    {
      field: "transferFrom",
      headerName: trans("Transfer From"),
      width: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      headerClassName: "header",
      height: 70,
    },
    {
      field: "transferTo",
      headerName: trans("Transfer To"),
      width: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      headerClassName: "header",
      height: 70,
    },

    {
      field: "transferDate",
      headerName: trans("Transfer Date"),
      width: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      headerClassName: "header",
      height: 70,
    },

    {
      field: "action",
      flex: 1,
      headerName: trans("Action"),
      headerClassName: "header",
      headerAlign: "center",
      align: "center",
      renderCell: (params: any) => {
        return (
          <GetPayHistoryActionBox
            onView={() => {
              setOpenModal(true);
            }}
          />
        );
      },

      width: 200,
      height: 70,
    },
  ];

  const row_data = [
    {
      id: 1,
      empId: "#8121",
      transferFrom: "Google",
      transferTo: "Alphabet HQ",
      transferDate: "24 Jun, 2023",
    },
  ];
  return (
    <>
      <Box
        className="ar_table"
        sx={{
          "& .header": {
            backgroundColor: "#F5F5F5",
          },

          width: "100%",
          marginTop: "2em",
        }}
      >
        <DataGrid
          sx={{
            color: "#081735",
            font: "normal normal normal 14px/24px Lato;",
          }}
          autoHeight
          disableExtendRowFullWidth
          disableSelectionOnClick
          rows={row_data}
          columns={tableColumns}
          componentsProps={{
            pagination: {
              labelRowsPerPage: trans("Rows per page"),
            },
          }}
        />
      </Box>
      {openModal && (
        <TransferReceiveARModalController
          closeModal={() => setOpenModal(false)}
          isModalOpen={openModal}
        />
      )}
    </>
  );
};

export default TransferReceive;
